export const isPlaceholder = (value, placeholders = ["--Select--"]) => {
  const text = String(value ?? "").trim();
  if (!text) return true;
  const normalized = text.toLowerCase();
  return (placeholders || []).some(
    (p) => String(p ?? "").trim().toLowerCase() === normalized
  );
};
